var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"base-radio radio"},[_c('input',{attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"radio-check"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }